// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.15.3
//   protoc               v7.36.2
// source: proto/logiblocks/node_run_report.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { DayOfWeekSet, SpecificDateSet, VariableValue } from "./logiblocks";

export const protobufPackage = "protobuf.logiblocks";

export enum ConditionOutcome {
  /**
   * CONDITION_OUTCOME_UNSPECIFIED - The proto3 default for an unset field. The Conditional sets an outcome on every
   * ConditionReport it writes, so a report holding this value is malformed.
   */
  CONDITION_OUTCOME_UNSPECIFIED = 0,
  CONDITION_OUTCOME_PASSED = 1,
  CONDITION_OUTCOME_FAILED = 2,
  /** CONDITION_OUTCOME_NOT_EVALUATED - Skipped by short-circuiting: an earlier condition already decided the group. */
  CONDITION_OUTCOME_NOT_EVALUATED = 3,
  UNRECOGNIZED = -1,
}

export function conditionOutcomeFromJSON(object: any): ConditionOutcome {
  switch (object) {
    case 0:
    case "CONDITION_OUTCOME_UNSPECIFIED":
      return ConditionOutcome.CONDITION_OUTCOME_UNSPECIFIED;
    case 1:
    case "CONDITION_OUTCOME_PASSED":
      return ConditionOutcome.CONDITION_OUTCOME_PASSED;
    case 2:
    case "CONDITION_OUTCOME_FAILED":
      return ConditionOutcome.CONDITION_OUTCOME_FAILED;
    case 3:
    case "CONDITION_OUTCOME_NOT_EVALUATED":
      return ConditionOutcome.CONDITION_OUTCOME_NOT_EVALUATED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConditionOutcome.UNRECOGNIZED;
  }
}

export function conditionOutcomeToJSON(object: ConditionOutcome): string {
  switch (object) {
    case ConditionOutcome.CONDITION_OUTCOME_UNSPECIFIED:
      return "CONDITION_OUTCOME_UNSPECIFIED";
    case ConditionOutcome.CONDITION_OUTCOME_PASSED:
      return "CONDITION_OUTCOME_PASSED";
    case ConditionOutcome.CONDITION_OUTCOME_FAILED:
      return "CONDITION_OUTCOME_FAILED";
    case ConditionOutcome.CONDITION_OUTCOME_NOT_EVALUATED:
      return "CONDITION_OUTCOME_NOT_EVALUATED";
    case ConditionOutcome.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * What a node did during one run, stored on its WorkflowRunNodeStatus row. A report holds only
 * what the run produced; the reader gets the node's settings from the graph that ran.
 */
export interface NodeRunReport {
  conditional?: ConditionalReport | undefined;
}

/** How a Conditional node evaluated its conditions. */
export interface ConditionalReport {
  /** Whether the conditions passed, so the node's children ran. */
  passed: boolean;
  /** The report for ConditionalData.root. */
  root: ConditionGroupReport | undefined;
}

/**
 * How one BoolExprGroup evaluated. `conditions[i]` reports on the group's `expressions[i]`, so
 * every expression has an entry, including those skipped by short-circuiting.
 */
export interface ConditionGroupReport {
  conditions: ConditionReport[];
}

/** How one BoolExpr evaluated. */
export interface ConditionReport {
  outcome: ConditionOutcome;
  /**
   * The value the condition's left-hand variable held when the condition was checked. Unset if
   * the variable had no value, the condition wasn't evaluated, or the condition is a group.
   */
  variable_value: VariableValue | undefined;
  group?: ConditionGroupReport | undefined;
  comparison?: ComparisonReport | undefined;
  date_time_set?: DateTimeSetReport | undefined;
}

/**
 * The right-hand values a ComparisonExpr compared against, as the run resolved them. Each is set
 * when its side (`rhs`, `rhs2`) resolved to a value, including a literal. A list
 * right-hand side, for IN_LIST or a multi-select CONTAINS, is in the graph.
 */
export interface ComparisonReport {
  rhs_value: VariableValue | undefined;
  rhs2_value: VariableValue | undefined;
}

/**
 * What a DateTimeSetExpr's set resolved to when it was checked. A preset or saved list can change
 * after the run, so its entries are kept here.
 */
export interface DateTimeSetReport {
  /**
   * Whether the set's source resolved. If not, the condition failed and the other fields are
   * unset.
   */
  resolved: boolean;
  /** The set's name: the preset's or saved list's name, or the inline set's label. */
  name: string;
  /** The IANA zone the variable's value was checked in. Holiday presets use the company's zone. */
  iana_timezone: string;
  /** How many entries the set had. */
  entry_count: number;
  specific_dates?: SpecificDateSet | undefined;
  days_of_week?: DayOfWeekSet | undefined;
}

function createBaseNodeRunReport(): NodeRunReport {
  return { conditional: undefined };
}

export const NodeRunReport: MessageFns<NodeRunReport> = {
  encode(message: NodeRunReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.conditional !== undefined) {
      ConditionalReport.encode(message.conditional, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeRunReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseNodeRunReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.conditional = ConditionalReport.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): NodeRunReport {
    return { conditional: isSet(object.conditional) ? ConditionalReport.fromJSON(object.conditional) : undefined };
  },

  toJSON(message: NodeRunReport): unknown {
    const obj: any = {};
    if (message.conditional !== undefined) {
      obj.conditional = ConditionalReport.toJSON(message.conditional);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeRunReport>, I>>(base?: I): NodeRunReport {
    return NodeRunReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeRunReport>, I>>(object: I): NodeRunReport {
    const message = createBaseNodeRunReport();
    message.conditional = (object.conditional !== undefined && object.conditional !== null)
      ? ConditionalReport.fromPartial(object.conditional)
      : undefined;
    return message;
  },
};

function createBaseConditionalReport(): ConditionalReport {
  return { passed: false, root: undefined };
}

export const ConditionalReport: MessageFns<ConditionalReport> = {
  encode(message: ConditionalReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.passed !== false) {
      writer.uint32(8).bool(message.passed);
    }
    if (message.root !== undefined) {
      ConditionGroupReport.encode(message.root, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConditionalReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseConditionalReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.passed = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.root = ConditionGroupReport.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ConditionalReport {
    return {
      passed: isSet(object.passed) ? globalThis.Boolean(object.passed) : false,
      root: isSet(object.root) ? ConditionGroupReport.fromJSON(object.root) : undefined,
    };
  },

  toJSON(message: ConditionalReport): unknown {
    const obj: any = {};
    if (message.passed !== false) {
      obj.passed = message.passed;
    }
    if (message.root !== undefined) {
      obj.root = ConditionGroupReport.toJSON(message.root);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionalReport>, I>>(base?: I): ConditionalReport {
    return ConditionalReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionalReport>, I>>(object: I): ConditionalReport {
    const message = createBaseConditionalReport();
    message.passed = object.passed ?? false;
    message.root = (object.root !== undefined && object.root !== null)
      ? ConditionGroupReport.fromPartial(object.root)
      : undefined;
    return message;
  },
};

function createBaseConditionGroupReport(): ConditionGroupReport {
  return { conditions: [] };
}

export const ConditionGroupReport: MessageFns<ConditionGroupReport> = {
  encode(message: ConditionGroupReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.conditions) {
      ConditionReport.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConditionGroupReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseConditionGroupReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.conditions.push(ConditionReport.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ConditionGroupReport {
    return {
      conditions: globalThis.Array.isArray(object?.conditions)
        ? object.conditions.map((e: any) => ConditionReport.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ConditionGroupReport): unknown {
    const obj: any = {};
    if (message.conditions?.length) {
      obj.conditions = message.conditions.map((e) => ConditionReport.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionGroupReport>, I>>(base?: I): ConditionGroupReport {
    return ConditionGroupReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionGroupReport>, I>>(object: I): ConditionGroupReport {
    const message = createBaseConditionGroupReport();
    message.conditions = object.conditions?.map((e) => ConditionReport.fromPartial(e)) || [];
    return message;
  },
};

function createBaseConditionReport(): ConditionReport {
  return { outcome: 0, variable_value: undefined, group: undefined, comparison: undefined, date_time_set: undefined };
}

export const ConditionReport: MessageFns<ConditionReport> = {
  encode(message: ConditionReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.outcome !== 0) {
      writer.uint32(8).int32(message.outcome);
    }
    if (message.variable_value !== undefined) {
      VariableValue.encode(message.variable_value, writer.uint32(18).fork()).join();
    }
    if (message.group !== undefined) {
      ConditionGroupReport.encode(message.group, writer.uint32(26).fork()).join();
    }
    if (message.comparison !== undefined) {
      ComparisonReport.encode(message.comparison, writer.uint32(34).fork()).join();
    }
    if (message.date_time_set !== undefined) {
      DateTimeSetReport.encode(message.date_time_set, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConditionReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseConditionReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.outcome = reader.int32() as any;
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.variable_value = VariableValue.decode(reader, reader.uint32());
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.group = ConditionGroupReport.decode(reader, reader.uint32());
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.comparison = ComparisonReport.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.date_time_set = DateTimeSetReport.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ConditionReport {
    return {
      outcome: isSet(object.outcome) ? conditionOutcomeFromJSON(object.outcome) : 0,
      variable_value: isSet(object.variableValue)
        ? VariableValue.fromJSON(object.variableValue)
        : isSet(object.variable_value)
        ? VariableValue.fromJSON(object.variable_value)
        : undefined,
      group: isSet(object.group) ? ConditionGroupReport.fromJSON(object.group) : undefined,
      comparison: isSet(object.comparison) ? ComparisonReport.fromJSON(object.comparison) : undefined,
      date_time_set: isSet(object.dateTimeSet)
        ? DateTimeSetReport.fromJSON(object.dateTimeSet)
        : isSet(object.date_time_set)
        ? DateTimeSetReport.fromJSON(object.date_time_set)
        : undefined,
    };
  },

  toJSON(message: ConditionReport): unknown {
    const obj: any = {};
    if (message.outcome !== 0) {
      obj.outcome = conditionOutcomeToJSON(message.outcome);
    }
    if (message.variable_value !== undefined) {
      obj.variableValue = VariableValue.toJSON(message.variable_value);
    }
    if (message.group !== undefined) {
      obj.group = ConditionGroupReport.toJSON(message.group);
    }
    if (message.comparison !== undefined) {
      obj.comparison = ComparisonReport.toJSON(message.comparison);
    }
    if (message.date_time_set !== undefined) {
      obj.dateTimeSet = DateTimeSetReport.toJSON(message.date_time_set);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConditionReport>, I>>(base?: I): ConditionReport {
    return ConditionReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConditionReport>, I>>(object: I): ConditionReport {
    const message = createBaseConditionReport();
    message.outcome = object.outcome ?? 0;
    message.variable_value = (object.variable_value !== undefined && object.variable_value !== null)
      ? VariableValue.fromPartial(object.variable_value)
      : undefined;
    message.group = (object.group !== undefined && object.group !== null)
      ? ConditionGroupReport.fromPartial(object.group)
      : undefined;
    message.comparison = (object.comparison !== undefined && object.comparison !== null)
      ? ComparisonReport.fromPartial(object.comparison)
      : undefined;
    message.date_time_set = (object.date_time_set !== undefined && object.date_time_set !== null)
      ? DateTimeSetReport.fromPartial(object.date_time_set)
      : undefined;
    return message;
  },
};

function createBaseComparisonReport(): ComparisonReport {
  return { rhs_value: undefined, rhs2_value: undefined };
}

export const ComparisonReport: MessageFns<ComparisonReport> = {
  encode(message: ComparisonReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rhs_value !== undefined) {
      VariableValue.encode(message.rhs_value, writer.uint32(10).fork()).join();
    }
    if (message.rhs2_value !== undefined) {
      VariableValue.encode(message.rhs2_value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ComparisonReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseComparisonReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.rhs_value = VariableValue.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.rhs2_value = VariableValue.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ComparisonReport {
    return {
      rhs_value: isSet(object.rhsValue)
        ? VariableValue.fromJSON(object.rhsValue)
        : isSet(object.rhs_value)
        ? VariableValue.fromJSON(object.rhs_value)
        : undefined,
      rhs2_value: isSet(object.rhs2Value)
        ? VariableValue.fromJSON(object.rhs2Value)
        : isSet(object.rhs2_value)
        ? VariableValue.fromJSON(object.rhs2_value)
        : undefined,
    };
  },

  toJSON(message: ComparisonReport): unknown {
    const obj: any = {};
    if (message.rhs_value !== undefined) {
      obj.rhsValue = VariableValue.toJSON(message.rhs_value);
    }
    if (message.rhs2_value !== undefined) {
      obj.rhs2Value = VariableValue.toJSON(message.rhs2_value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ComparisonReport>, I>>(base?: I): ComparisonReport {
    return ComparisonReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ComparisonReport>, I>>(object: I): ComparisonReport {
    const message = createBaseComparisonReport();
    message.rhs_value = (object.rhs_value !== undefined && object.rhs_value !== null)
      ? VariableValue.fromPartial(object.rhs_value)
      : undefined;
    message.rhs2_value = (object.rhs2_value !== undefined && object.rhs2_value !== null)
      ? VariableValue.fromPartial(object.rhs2_value)
      : undefined;
    return message;
  },
};

function createBaseDateTimeSetReport(): DateTimeSetReport {
  return {
    resolved: false,
    name: "",
    iana_timezone: "",
    entry_count: 0,
    specific_dates: undefined,
    days_of_week: undefined,
  };
}

export const DateTimeSetReport: MessageFns<DateTimeSetReport> = {
  encode(message: DateTimeSetReport, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.resolved !== false) {
      writer.uint32(8).bool(message.resolved);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.iana_timezone !== "") {
      writer.uint32(26).string(message.iana_timezone);
    }
    if (message.entry_count !== 0) {
      writer.uint32(32).int32(message.entry_count);
    }
    if (message.specific_dates !== undefined) {
      SpecificDateSet.encode(message.specific_dates, writer.uint32(42).fork()).join();
    }
    if (message.days_of_week !== undefined) {
      DayOfWeekSet.encode(message.days_of_week, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DateTimeSetReport {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDateTimeSetReport();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.resolved = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.name = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.iana_timezone = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.entry_count = reader.int32();
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.specific_dates = SpecificDateSet.decode(reader, reader.uint32());
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.days_of_week = DayOfWeekSet.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DateTimeSetReport {
    return {
      resolved: isSet(object.resolved) ? globalThis.Boolean(object.resolved) : false,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      iana_timezone: isSet(object.ianaTimezone)
        ? globalThis.String(object.ianaTimezone)
        : isSet(object.iana_timezone)
        ? globalThis.String(object.iana_timezone)
        : "",
      entry_count: isSet(object.entryCount)
        ? globalThis.Number(object.entryCount)
        : isSet(object.entry_count)
        ? globalThis.Number(object.entry_count)
        : 0,
      specific_dates: isSet(object.specificDates)
        ? SpecificDateSet.fromJSON(object.specificDates)
        : isSet(object.specific_dates)
        ? SpecificDateSet.fromJSON(object.specific_dates)
        : undefined,
      days_of_week: isSet(object.daysOfWeek)
        ? DayOfWeekSet.fromJSON(object.daysOfWeek)
        : isSet(object.days_of_week)
        ? DayOfWeekSet.fromJSON(object.days_of_week)
        : undefined,
    };
  },

  toJSON(message: DateTimeSetReport): unknown {
    const obj: any = {};
    if (message.resolved !== false) {
      obj.resolved = message.resolved;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.iana_timezone !== "") {
      obj.ianaTimezone = message.iana_timezone;
    }
    if (message.entry_count !== 0) {
      obj.entryCount = Math.round(message.entry_count);
    }
    if (message.specific_dates !== undefined) {
      obj.specificDates = SpecificDateSet.toJSON(message.specific_dates);
    }
    if (message.days_of_week !== undefined) {
      obj.daysOfWeek = DayOfWeekSet.toJSON(message.days_of_week);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateTimeSetReport>, I>>(base?: I): DateTimeSetReport {
    return DateTimeSetReport.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateTimeSetReport>, I>>(object: I): DateTimeSetReport {
    const message = createBaseDateTimeSetReport();
    message.resolved = object.resolved ?? false;
    message.name = object.name ?? "";
    message.iana_timezone = object.iana_timezone ?? "";
    message.entry_count = object.entry_count ?? 0;
    message.specific_dates = (object.specific_dates !== undefined && object.specific_dates !== null)
      ? SpecificDateSet.fromPartial(object.specific_dates)
      : undefined;
    message.days_of_week = (object.days_of_week !== undefined && object.days_of_week !== null)
      ? DayOfWeekSet.fromPartial(object.days_of_week)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
